import produce from "immer"
import type { HttpResponse } from "../redux/http/http.types"
import { dispatchSnackbar } from "../services/SnackbarService"
import { hasFailed } from "../utils"
import type {
  AddContentToBundleCommand,
  BundleDetailDto,
  BundleDto,
  CreateBundleCommand,
  UpdateBundleCommand
} from "./../models/models"
import { get, post, put, remove } from "./HttpService"

export async function getBundle(bundleId: string): Promise<BundleDetailDto> {
  const response: HttpResponse<BundleDetailDto> = await get<BundleDetailDto>("bundle", `Bundles/${bundleId}`)

  return response.data!
}

export async function getBundleList(): Promise<BundleDto[]> {
  const response: HttpResponse<BundleDto[]> = await get<BundleDto[]>("bundle", "Bundles")

  return response.data!
}

export async function searchBundles(title: string): Promise<BundleDto[]> {
  const response: HttpResponse<BundleDto[]> = await get<BundleDto[]>("bundle", `Bundles/search?title=${title}`)

  return response.data!
}

export async function createNewBundle(title: string): Promise<string> {
  const command: CreateBundleCommand = {
    title
  }

  const response: HttpResponse<string> = await post<string, CreateBundleCommand>("bundle", "Bundles", command)
  dispatchSnackbar("map", "POST", !hasFailed(response))
  return response.data!
}

export async function removeBundle(id: string): Promise<void> {
  const response: HttpResponse = await remove("bundle", `Bundles/${id}`)

  dispatchSnackbar("map", "DELETE", !hasFailed(response))
}

export async function addToBundle(id: string, projectIds: string[], comparisonIds: string[]): Promise<void> {
  const command: AddContentToBundleCommand = {
    id,
    projectIds,
    comparisonIds
  }

  await put("bundle", "Bundles/Add", command)
}

export async function updateExistingBundle(bundleId: string, title: string): Promise<void> {
  const command: UpdateBundleCommand = {
    id: bundleId,
    title
  }

  const response: HttpResponse = await put<UpdateBundleCommand>("bundle", "Bundles", command)

  dispatchSnackbar("map", "PUT", !hasFailed(response))
}

export function populateBundleDates(bundle: BundleDto): BundleDto {
  return produce(bundle, (draft: BundleDto) => {
    draft.created = new Date(draft.created)
    if (draft.lastModified) {
      draft.lastModified = new Date(draft.lastModified)
    }
  })
}
